/* eslint-disable react/prop-types */
import * as React from 'react';
import { formatTime, getValidPrice } from '@/utils';
// import DOLLAR from '@assets/shopify_icon.png';
import { ICON_MAP } from '@constants';
import useSettings from '@hooks/useSettings';
import classes from './GridItem.module.css';

const GridItem = React.memo((props) => {
  const { type = 'normal', children } = props;
  const className = `${classes.itemDetail} ${type === 'dollar' ? `${classes.itemDollar}` : ''}`;
  return (<div className={className}>{children}</div>);
});

const getCoveragePeriod = (startTime, endTime, timeZone) => {
  if (!startTime && !endTime) {
    return '--';
  }
  const format = 'MMM DD';
  const startFormat = formatTime(startTime, format, timeZone) || '--';
  const endFormat = formatTime(endTime, format, timeZone) || '--';

  return `${startFormat} - ${endFormat}`;
};

export const CoveragePeriodGrid = (value) => {
  const { settingsInfo: { timeZone } = {} } = useSettings();

  const { startTime, endTime } = value || {};
  return <GridItem>{getCoveragePeriod(startTime, endTime, timeZone)}</GridItem>;
};

export const PriceGrid = (value) => <GridItem type="dollar">{value ? `$${getValidPrice(value)} USD` : '--'}</GridItem>;
export const CurrencyPriceGrid = ({
  value, customerCurrency, shopCurrency, customerValue, shopValue, shopCurrencySymbol,
}) => {
  // 商家币种和消费者币种不同时，需要展示消费者币种
  if (customerCurrency !== shopCurrency) {
    return (
      <>
        <GridItem type="dollar">{shopValue || (value ? `${shopCurrencySymbol || '$'}${getValidPrice(value)} ${shopCurrency || 'USD'}` : '--')}</GridItem>
        <div className={classes.customer_money}>
          {customerValue && `(${customerValue} paid by customer)`}
        </div>
      </>
    );
  }
  return (
    <GridItem type="dollar">{customerValue || (value ? `${shopCurrencySymbol || '$'}${getValidPrice(value)} ${shopCurrency || 'USD'}` : '--')}</GridItem>
  );
};
export const ReturnMethodGrid = (value) => (
  <GridItem>
    Return to
    <span className={classes.returnMethod}>{value}</span>
  </GridItem>
);

export const OrderNumberGrid = ({
  orderName, sellerUsername, treetShopId, sellerPlatform, platform,
}) => {
  const text = treetShopId || sellerPlatform;
  const icon = ICON_MAP[platform];
  return (
    <GridItem>
      <div className={classes.order_name_block}>
        <div className={classes.order_name}>
          {icon && <img className={classes.dollarIcon} src={icon} alt="" />}
          <section>{orderName}</section>
        </div>
        {text && <div>{text}</div>}
        {sellerUsername
          && (
            <div>
              {`Sold by ${sellerUsername}`}
            </div>
          )}
      </div>
    </GridItem>
  );
};

export const CustomerGrid = (customer) => {
  const { firstName, lastName, customerEmail } = customer || {};
  return (
    <GridItem>
      <div className={classes.customerName}>
        <div>{`${firstName || ''} ${lastName || ''}`}</div>
        {customerEmail ? <div>{customerEmail}</div> : ''}
      </div>
    </GridItem>
  );
};

export const TextGrid = (value) => <GridItem>{value}</GridItem>;

export const CoverageGrid = (value = []) => {
  console.log(value, 'valuevaluevalue');
  if (!value.length) return null;
  if (value.length < 2) {
    return <GridItem><ul style={{ paddingLeft: 14, textAlign: 'left' }}>{value.map((i) => <li key={i}>{i}</li>)}</ul></GridItem>;
  }
  return <GridItem>{value.join(', ')}</GridItem>;

  // return (value.length > 0 ? <GridItem><ul style={{ paddingLeft: 14, textAlign: 'left' }}>{value.map((i) => <li key={i}>{i}</li>)}</ul></GridItem> : <div style={{ textAlign: 'left' }}>--</div>);
};
